import { Fortigate } from '@app/shared/models/fortigate/fortigate.model';
import { Location } from '@app/shared/models/location.model';

export class FortigateLocation {
    public location: Location;
    public fortigates: Fortigate[];
    public storeNumber: string;
}